import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'km',
    fullName: 'Khmer',
    nativeName: 'ខ្មែរ',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "អ្វីមួយដែលអស្ចារ្យនឹងមកដល់",
    landing_subtitle: "ArgVoid គឺជាស្ទូឌីយោអភិវឌ្ឍន៍កម្មវិធី និងហ្គេម។ រង់ចាំមើលរឿងថ្មីៗនឹងមកដល់ឆាប់ៗនេះ!",
    select_language: "ជ្រើសរើសភាសា",
    search_placeholder: "ស្វែងរកភាសា...",
    terms_title: "លក្ខខណ្ឌនៃសេវាកម្ម",
    policy_title: "គោលការណ៍ឯកជនភាព",
    cookies_title: "គោលការណ៍ខូឃី",
    terms_content: `
        <strong>1 ។ ការទទួលយកលក្ខខណ្ឌ</strong><br>
        តាមរយៈការចូលប្រើ ArgVoid លក្ខខណ្ឌនៃសេវាកម្មទាំងនេះត្រូវបានទទួលយក។ ប្រសិនបើលក្ខខណ្ឌទាំងនេះមិនត្រូវបានយល់ព្រមទេ សេវាកម្មមិនគួរត្រូវបានប្រើប្រាស់ទេ។<br><br>

        <strong>2 ។ ការប្រើប្រាស់វេទិកា</strong><br>
        ArgVoid និងកម្មវិធីរបស់វាត្រូវបានផ្តល់ជូន "ដូចដែលមាន" សម្រាប់គោលបំណងផ្តល់ព័ត៌មាន និងច្នៃប្រឌិត។ សេវាកម្មត្រូវតែប្រើសម្រាប់គោលបំណងស្របច្បាប់ប៉ុណ្ណោះ។<br><br>

        <strong>3 ។ ហាមឃាត់ការប្រព្រឹត្ត</strong><br>
        ការកេងប្រវ័ញ្ចភាពងាយរងគ្រោះនៃគេហទំព័រ ការផ្ញើសារឥតបានការ ឬការប៉ុនប៉ងចូលប្រើប្រាស់ហេដ្ឋារចនាសម្ព័ន្ធដោយគ្មានការអនុញ្ញាតត្រូវបានហាមឃាត់យ៉ាងតឹងរ៉ឹង។<br><br>

        <strong>4 ។ ការបដិសេធ</strong><br>
        វេទិកា និងសេវាកម្មអាចត្រូវបានកែប្រែនៅពេលណាក៏បានដោយមិនចាំបាច់ជូនដំណឹងជាមុន។ គ្មានការធានាណាមួយត្រូវបានផ្តល់ជូនទាក់ទងនឹងពេលវេលាដំណើរការ ឬភាពអាចរកបាននៃសេវាកម្មនោះទេ។
    `,
    policy_content: `
        <strong>1 ។ ការប្រមូលព័ត៌មាន</strong><br>
        វេទិកានេះមិនតម្រូវឱ្យមានការផ្ទៀងផ្ទាត់អ្នកប្រើប្រាស់ ឬការបង្កើតគណនីនៅពេលនេះទេ។ គ្មានព័ត៌មានកំណត់អត្តសញ្ញាណផ្ទាល់ខ្លួន (ដូចជាឈ្មោះ ឬអាសយដ្ឋានអ៊ីមែល) ត្រូវបានប្រមូលយ៉ាងសកម្មពីអ្នកទស្សនា។<br><br>

        <strong>2 ។ ការប្រើប្រាស់ Data</strong><br>
        ការវិភាគអនាមិកជាមូលដ្ឋាន អាចត្រូវបានប្រមូល ដើម្បីយល់ពីចរាចរណ៍គេហទំព័រ និងកែលម្អកម្មវិធី។ ទិន្នន័យនេះមិនត្រូវបានភ្ជាប់ទៅអត្តសញ្ញាណអ្នកប្រើប្រាស់នីមួយៗទេ។<br><br>

        <strong>3 ។ សេវាកម្មភាគីទីបី</strong><br>
        អ្នកផ្តល់សេវាភាគីទីបីអាចត្រូវបានប្រើប្រាស់សម្រាប់សេវាបង្ហោះ និងវិភាគ។ ការអនុវត្តឯកជនភាពរបស់អ្នកផ្តល់សេវារៀងៗខ្លួនទាំងនេះគ្រប់គ្រងទិន្នន័យអនាមិកដែលបានដំណើរការលើហេដ្ឋារចនាសម្ព័ន្ធរបស់ពួកគេ។<br><br>

        <strong>4 ។ Data Security</strong><br>
        វិធានការសន្តិសុខសមហេតុផលត្រូវបានអនុវត្តដើម្បីការពារវេទិកា។ ទោះយ៉ាងណាក៏ដោយ គ្មានវិធីសាស្រ្តនៃការបញ្ជូនតាមអ៊ីនធឺណិតណាដែលមានសុវត្ថិភាពទាំងស្រុងនោះទេ។<br><br>
    `,
    cookies_content: `
        <strong>1 ។ តើខូគី និងកន្លែងផ្ទុកក្នុងមូលដ្ឋានជាអ្វី?</strong><br>
        ខូគី និងឧបករណ៍ផ្ទុកក្នុងកម្មវិធីរុករកតាមអ៊ីនធឺណិតគឺជាឯកសារទិន្នន័យតូចដែលរក្សាទុកនៅលើឧបករណ៍ដើម្បីចងចាំចំណូលចិត្តនៃការកំណត់រចនាសម្ព័ន្ធឆ្លងកាត់ការចូលមើល។<br><br>

        <strong>2 ។ គោលបំណងនៃការប្រើប្រាស់</strong><br>
        Browser LocalStorage ត្រូវបានប្រើយ៉ាងតឹងរ៉ឹង ដើម្បីរក្សាទុកការកំណត់រចនាសម្ព័ន្ធ ដូចជា៖ <br>
        - ចំណូលចិត្តភាសា<br>
        - ការកំណត់រចនាសម្ព័ន្ធចំណុចប្រទាក់អ្នកប្រើ (ឧ. ប្លង់ ឬការកំណត់ស្បែក) <br>
        - ឃ្លាំងសម្ងាត់កម្មវិធីបណ្តោះអាសន្ន<br><br>

        <strong>3 ។ គ្មាន Tracking</strong><br>
        ខូគី និងកន្លែងផ្ទុកក្នុងមូលដ្ឋានមិនត្រូវបានប្រើសម្រាប់ការផ្សាយពាណិជ្ជកម្ម ឬគោលបំណងតាមដានភាគីទីបីទេ។ ទិន្នន័យដែលបានរក្សាទុកទាំងអស់គឺយ៉ាងតឹងរ៉ឹងសម្រាប់មុខងារស្នូលនៃ platform.<br><br>

        <strong>4 ។ Control</strong><br>
        ទិន្នន័យកម្មវិធីរុករកតាមអ៊ីនធឺណិតអាចត្រូវបានសម្អាតគ្រប់ពេលតាមរយៈការកំណត់កម្មវិធីរុករក ដែលនឹងកំណត់ការកំណត់មូលដ្ឋានឡើងវិញ។
    `,
    cookie_consent_text: "យើងប្រើខូគីជាមូលដ្ឋាន ដើម្បីធានាថាគេហទំព័រដំណើរការបានត្រឹមត្រូវ ដូចជាការរក្សាវគ្គរបស់អ្នកឱ្យសកម្ម រក្សាទុកចំណូលចិត្តភាសារបស់អ្នក និងការកំណត់រចនាសម្ព័ន្ធផ្ទាល់ខ្លួនផ្សេងទៀត។",
    read_policy: "អានគោលការណ៍ខូគី",
    support_title: "ទាក់ទងផ្នែកជំនួយ",
    support_subject_label: "ប្រធានបទ",
    support_message_label: "សារ",
    support_submit_button: "ផ្ញើសារ",
    support_hint: "ចំណាំ៖ វានឹងបើកកម្មវិធីអ៊ីមែលលំនាំដើមរបស់អ្នក ដើម្បីផ្ញើសារ។",
    support_success_msg: "កំពុងបើកកម្មវិធីអ៊ីមែលរបស់អ្នក...",
    support_error_msg: "បរាជ័យក្នុងការផ្ញើសារ។ សូមព្យាយាមម្តងទៀតនៅពេលក្រោយ។",
    explorer_title: "អ្នករុករក",
    history_title: "ប្រវត្តិសាស្ត្រ",
    animation_title: "ចលនា",
    config_title: "ការកំណត់រចនាសម្ព័ន្ធ",
    tool_mouse: "ជ្រើសរើស (Ctrl+M)",
    tool_brush: "ជក់ (Ctrl+B)",
    tool_brush_mode: "របៀបបិទ/បើក (រឹង/ជម្រះ)",
    tool_eraser: "ជ័រលុប (Ctrl+E)",
    tool_brush_size: "លៃតម្រូវទំហំជក់",
    tool_bucket: "បំពេញ (Ctrl+F)",
    tool_eyedropper: "ដំណក់ភ្នែក",
    tool_grid: "ក្រឡាចត្រង្គ (Ctrl+Shift+B)",
    tool_rotate: "បង្វិល (Ctrl+Shift+R)",
    tool_flip_h: "ត្រឡប់ H (Ctrl+Shift+H)",
    tool_flip_v: "ត្រឡប់ V (Ctrl+Shift+V)",
    tool_transpose: "ប្តូរ (Ctrl+Shift+T)",
    label_width: "ទទឹង",
    label_height: "កម្ពស់",
    label_frames: "ចំនួនស៊ុម",
    label_animation: "រចនាប័ទ្មចលនា",
    label_background_color: "ពណ៌ផ្ទៃខាងក្រោយ",
    label_interval: "ចន្លោះពេល",
    tool_anim_config: "ការកំណត់រចនាសម្ព័ន្ធចលនា",
    label_new_width: "ទទឹងថ្មី។",
    label_new_height: "កម្ពស់ថ្មី។",
    label_apply: "អនុវត្ត",
    label_colors: "ពណ៌",
    label_size: "ទំហំ",
    label_tolerance: "ការអត់ឱន",
    val_horizontal: "ផ្ដេក",
    val_vertical: "បញ្ឈរ",
    val_sequence: "លំដាប់",
    val_bounce: "លោត",
    val_random: "ចៃដន្យ",
    val_solid: "រឹង",
    val_clear: "ច្បាស់",
    action_add_sheet: "សន្លឹកថ្មី។",
    action_import: "នាំចូល",
    action_export: "នាំចេញ",
    action_sort_projects: "តម្រៀប",
    sort_date_old: "ទីមួយចាស់ជាងគេ",
    sort_date_new: "ថ្មីបំផុតដំបូង",
    sort_name_az: "ឈ្មោះ (A-Z)",
    sort_name_za: "ឈ្មោះ (Z-A)",
    action_new_sprite: "Sprite ថ្មី។",
    action_new_project: "គម្រោងថ្មី។",
    modal_save_all_title: "រក្សាទុកការផ្លាស់ប្តូរទាំងអស់។",
    modal_save_all_desc: "ជ្រើសរើសទ្រព្យសម្បត្តិដើម្បីរក្សាទុក៖",
    modal_save_selected: "រក្សាទុកដែលបានជ្រើសរើស",
    action_saved: "បានរក្សាទុក",
    modal_create_sprite_title: "បង្កើត Sprite ថ្មី។",
    modal_create_project_title: "បង្កើតគម្រោងថ្មី។",
    modal_add_sheet_title: "បន្ថែមសន្លឹកថ្មី។",
    modal_rename_sheet_title: "ប្តូរឈ្មោះសន្លឹក",
    modal_rename_sprite_title: "ប្តូរឈ្មោះ Sprite",
    modal_delete_sprite_title: "លុប Sprite",
    modal_delete_project_title: "លុបគម្រោង",
    modal_delete_sheet_title: "លុបសន្លឹក",
    placeholder_sprite_name: "ឈ្មោះ",
    placeholder_project_name: "ឈ្មោះ",
    placeholder_sheet_name: "ឈ្មោះ",
    placeholder_new_name: "ឈ្មោះថ្មី។",
    action_create: "បង្កើត",
    action_add: "បន្ថែម",
    action_rename: "ប្តូរឈ្មោះ",
    action_duplicate: "ស្ទួន",
    action_delete: "លុប",
    action_cancel: "បោះបង់",
    confirm_delete_sprite: "តើអ្នកប្រាកដថាចង់លុប sprite នេះទេ?",
    confirm_delete_project: "តើអ្នកប្រាកដថាចង់លុបគម្រោងនេះទេ? Sprites ទាំងអស់នឹងត្រូវដកចេញ។",
    confirm_delete_sheet: "តើអ្នកប្រាកដថាចង់លុបសន្លឹកនេះទេ?",
    err_select_sprite: "សូមជ្រើសរើស sprite ជាមុនសិន។",
    err_select_project: "សូមជ្រើសរើសគម្រោងជាមុនសិន។",
    err_name_empty: "ឈ្មោះមិនអាចទទេបានទេ។",
    err_sprite_exists: "Sprite ដែលមានឈ្មោះនោះមានរួចហើយ។",
    err_project_exists: "គម្រោងដែលមានឈ្មោះនោះមានរួចហើយ។",
    err_no_content: "គ្មានខ្លឹមសារដែលត្រូវរក្សាទុកទេ។",
    err_no_changes: "មិនមានការផ្លាស់ប្តូរដើម្បីរក្សាទុកទេ។",
    err_delete_last_sheet: "មិនអាចលុបសន្លឹកចុងក្រោយបានទេ។",
    err_extract_frames: "មិន​អាច​ទាញ​យក​ស៊ុម​ណា​មួយ​ទេ។",
    err_indexeddb: "បានបរាជ័យក្នុងការរក្សាទុកក្នុងមូលដ្ឋាន។ កម្មវិធីរុករកតាមអ៊ីនធឺណិតរបស់អ្នកប្រហែលជាមិនគាំទ្រ IndexedDB ទេ។",
    msg_upload_success: "បង្ហោះជោគជ័យ៖ {0}",
    msg_upload_failed: "ការបង្ហោះបរាជ័យ៖ {0}",
    msg_save_success: "រក្សាទុកដោយជោគជ័យ។",
    msg_saving: "កំពុងរក្សាទុក...",
    msg_multi_save_result: "បានរក្សាទុកទ្រព្យសកម្ម {0} ។ បរាជ័យ {1} ។",
    menu_title: "ម៉ឺនុយ",
    menu_save: "រក្សាទុក",
    menu_save_all: "រក្សាទុកទាំងអស់។",
    menu_support: "ទាក់ទងផ្នែកជំនួយ",
    label_local_storage: "កន្លែងផ្ទុកក្នុងស្រុក",
    label_sign_in: "ចូល",
    modal_export_title: "នាំចេញ Sprite",
    label_filename: "ឈ្មោះឯកសារ",
    label_format: "ទម្រង់",
    action_export_confirm: "នាំចេញ",
};

export default translations;
